import { getVisorServerUrl } from 'src/utils/env'
import { TranscriptOld, TranscriptJSON } from 'src/models/TranscriptOld'
import { Transcript } from 'src/models/Transcript'
import {
    TranscriptionDocumentMetadata,
    TranscriptionDocumentMetadataJSON,
    toTranscriptionDocumentMetadata,
} from 'src/models/TranscriptionDocumentMetadata'
import { Testimony, TestimonyResponse, TestimonyUpdateRequest } from 'src/models/Testimony'

import { HttpClientBase } from './HttpClientBase'
import { VisorHttpClientInterface } from './HttpClientInterface'

export class VisorHttpClient extends HttpClientBase implements VisorHttpClientInterface {
    constructor() {
        super({
            baseURL: `${getVisorServerUrl()}/api/`,
        })
    }

    async getMetadata(transcriptionDocumentId: string): Promise<TranscriptionDocumentMetadata> {
        const json = await this.get<TranscriptionDocumentMetadataJSON>(`/testimonies/${transcriptionDocumentId}/metadata`, {
            withCredentials: true,
            requiresAuth: true,
        })

        return toTranscriptionDocumentMetadata(json)
    }

    async getTranscript(transcriptionDocumentId: string): Promise<Transcript> {
        const json = await this.get<TranscriptJSON>(`/testimonies/${transcriptionDocumentId}/transcript`, {
            withCredentials: true,
            requiresAuth: true,
        })

        if (TranscriptOld.isValidJSON(json)) {
            const transcriptOld = TranscriptOld.fromJSON(json)

            return Transcript.fromOldStructure(transcriptOld)
        }

        console.warn('[VisorHttpClient] Invalid transcript JSON', json)

        return Transcript.EMPTY
    }

    async getTestimony(testimonyId: string): Promise<Testimony> {
        const response = await this.get<TestimonyResponse>(`/testimonies/${testimonyId}`, {
            withCredentials: true,
        })

        return response.testimony
    }

    async updateTestimony(testimonyId: string, payload: TestimonyUpdateRequest): Promise<Testimony> {
        const response = await this.patch<TestimonyResponse>(`/testimonies/${testimonyId}`, {
            withCredentials: true,
            data: payload,
        })

        return response.testimony
    }
}
